import { Array } from 'stdlib/Array'

import type { TBrowser } from '../definitions'
import { OPERA_BROWSERS } from '../definitions'

/**
 * Operát használ a user.
 * @param browser - Browser típusa.
 */
export default function isOpera (browser: TBrowser): boolean {
  return Array.includes(OPERA_BROWSERS, browser)
}
